/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTreeDefinitionRequest } from '../models/CreateTreeDefinitionRequest';
import type { CreateTreeLevelRequest } from '../models/CreateTreeLevelRequest';
import type { CreateTreeNodeRequest } from '../models/CreateTreeNodeRequest';
import type { FinderSettingsDto } from '../models/FinderSettingsDto';
import type { SectorUnitTypeMappingDto } from '../models/SectorUnitTypeMappingDto';
import type { TreeDefinitionDto } from '../models/TreeDefinitionDto';
import type { TreeDefinitionSummaryDto } from '../models/TreeDefinitionSummaryDto';
import type { TreeLevelDto } from '../models/TreeLevelDto';
import type { TreeNodeDto } from '../models/TreeNodeDto';
import type { UpdateTreeDefinitionRequest } from '../models/UpdateTreeDefinitionRequest';
import type { UpdateTreeLevelRequest } from '../models/UpdateTreeLevelRequest';
import type { UpdateTreeNodeRequest } from '../models/UpdateTreeNodeRequest';
import type { UpsertFinderSettingsForNodeRequest } from '../models/UpsertFinderSettingsForNodeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TreeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param orgGuid
     * @returns TreeDefinitionSummaryDto OK
     * @throws ApiError
     */
    public getAllTreeDefinitions(
        orgGuid: string,
    ): CancelablePromise<Array<TreeDefinitionSummaryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{orgGuid}/GetAllTreeDefinitions',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeDefinitionGuid
     * @returns TreeDefinitionDto OK
     * @throws ApiError
     */
    public getTreeDefinition(
        treeDefinitionGuid: string,
    ): CancelablePromise<TreeDefinitionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{treeDefinitionGuid}/GetTreeDefinition',
            path: {
                'treeDefinitionGuid': treeDefinitionGuid,
            },
        });
    }
    /**
     * @param orgGuid
     * @param treeType
     * @returns TreeDefinitionDto OK
     * @throws ApiError
     */
    public getTreeDefinitionByType(
        orgGuid: string,
        treeType: string,
    ): CancelablePromise<TreeDefinitionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{orgGuid}/GetTreeDefinitionByType/{treeType}',
            path: {
                'orgGuid': orgGuid,
                'treeType': treeType,
            },
        });
    }
    /**
     * @param orgGuid
     * @returns TreeDefinitionDto OK
     * @throws ApiError
     */
    public getGeoTreePublic(
        orgGuid: string,
    ): CancelablePromise<TreeDefinitionDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{orgGuid}/GetGeoTreePublic',
            path: {
                'orgGuid': orgGuid,
            },
        });
    }
    /**
     * @param orgGuid
     * @param requestBody
     * @returns TreeDefinitionDto OK
     * @throws ApiError
     */
    public createTreeDefinition(
        orgGuid: string,
        requestBody?: CreateTreeDefinitionRequest,
    ): CancelablePromise<TreeDefinitionDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Tree/{orgGuid}/CreateTreeDefinition',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeDefinitionGuid
     * @param requestBody
     * @returns TreeDefinitionDto OK
     * @throws ApiError
     */
    public updateTreeDefinition(
        treeDefinitionGuid: string,
        requestBody?: UpdateTreeDefinitionRequest,
    ): CancelablePromise<TreeDefinitionDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Tree/{treeDefinitionGuid}/UpdateTreeDefinition',
            path: {
                'treeDefinitionGuid': treeDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeDefinitionGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteTreeDefinition(
        treeDefinitionGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Tree/{treeDefinitionGuid}/DeleteTreeDefinition',
            path: {
                'treeDefinitionGuid': treeDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeDefinitionGuid
     * @param requestBody
     * @returns TreeLevelDto OK
     * @throws ApiError
     */
    public createTreeLevel(
        treeDefinitionGuid: string,
        requestBody?: CreateTreeLevelRequest,
    ): CancelablePromise<TreeLevelDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Tree/{treeDefinitionGuid}/CreateTreeLevel',
            path: {
                'treeDefinitionGuid': treeDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeLevelGuid
     * @param requestBody
     * @returns TreeLevelDto OK
     * @throws ApiError
     */
    public updateTreeLevel(
        treeLevelGuid: string,
        requestBody?: UpdateTreeLevelRequest,
    ): CancelablePromise<TreeLevelDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Tree/{treeLevelGuid}/UpdateTreeLevel',
            path: {
                'treeLevelGuid': treeLevelGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeLevelGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteTreeLevel(
        treeLevelGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Tree/{treeLevelGuid}/DeleteTreeLevel',
            path: {
                'treeLevelGuid': treeLevelGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeDefinitionGuid
     * @param requestBody
     * @returns TreeNodeDto OK
     * @throws ApiError
     */
    public createTreeNode(
        treeDefinitionGuid: string,
        requestBody?: CreateTreeNodeRequest,
    ): CancelablePromise<TreeNodeDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Tree/{treeDefinitionGuid}/CreateTreeNode',
            path: {
                'treeDefinitionGuid': treeDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeNodeGuid
     * @param requestBody
     * @returns TreeNodeDto OK
     * @throws ApiError
     */
    public updateTreeNode(
        treeNodeGuid: string,
        requestBody?: UpdateTreeNodeRequest,
    ): CancelablePromise<TreeNodeDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Tree/{treeNodeGuid}/UpdateTreeNode',
            path: {
                'treeNodeGuid': treeNodeGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeNodeGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteTreeNode(
        treeNodeGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Tree/{treeNodeGuid}/DeleteTreeNode',
            path: {
                'treeNodeGuid': treeNodeGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param nodeGuid
     * @returns TreeNodeDto OK
     * @throws ApiError
     */
    public getAncestorPath(
        nodeGuid: string,
    ): CancelablePromise<Array<TreeNodeDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{nodeGuid}/GetAncestorPath',
            path: {
                'nodeGuid': nodeGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeNodeGuid
     * @returns FinderSettingsDto OK
     * @throws ApiError
     */
    public getFinderSettingsForNode(
        treeNodeGuid: string,
    ): CancelablePromise<FinderSettingsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{treeNodeGuid}/GetFinderSettingsForNode',
            path: {
                'treeNodeGuid': treeNodeGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeNodeGuid
     * @param requestBody
     * @returns FinderSettingsDto OK
     * @throws ApiError
     */
    public upsertFinderSettingsForNode(
        treeNodeGuid: string,
        requestBody?: UpsertFinderSettingsForNodeRequest,
    ): CancelablePromise<FinderSettingsDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Tree/{treeNodeGuid}/UpsertFinderSettingsForNode',
            path: {
                'treeNodeGuid': treeNodeGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param treeNodeGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteFinderSettingsForNode(
        treeNodeGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Tree/{treeNodeGuid}/DeleteFinderSettingsForNode',
            path: {
                'treeNodeGuid': treeNodeGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Returns every allowed (sector leaf, unit type leaf) pair for the org. The frontend
     * uses this to drive the dynamic unit-type dropdown in EditSite.
     * @param orgGuid
     * @returns SectorUnitTypeMappingDto OK
     * @throws ApiError
     */
    public getSectorUnitTypeMappings(
        orgGuid: string,
    ): CancelablePromise<Array<SectorUnitTypeMappingDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Tree/{orgGuid}/GetSectorUnitTypeMappings',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Replaces the full set of sector → unit-type mappings for the org. All nodes must
     * belong to the org's SectorSetup / UnitType trees respectively.
     * @param orgGuid
     * @param requestBody
     * @returns SectorUnitTypeMappingDto OK
     * @throws ApiError
     */
    public updateSectorUnitTypeMappings(
        orgGuid: string,
        requestBody?: Array<SectorUnitTypeMappingDto>,
    ): CancelablePromise<Array<SectorUnitTypeMappingDto>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Tree/{orgGuid}/UpdateSectorUnitTypeMappings',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
